import React from 'react'
import styles from './notes.module.scss'
import { useSceneActions } from 'features/Procedure/hooks/useSceneActions'
import type { DrawingElement } from 'features/Procedure/state/procedure.type'
type Props = {
  element: DrawingElement
}

export const NoteId = ({ element }: Props) => {
  const { handleSetDesiredCameraPosition } = useSceneActions()

  const handleClick = () => {
    const point = element.points[0]
    const target = { x: point.x, y: point.y, z: point.z }

    const cameraOffset = 2
    const position = {
      x: point.x,
      y: point.y + cameraOffset,
      z: point.z + cameraOffset,
    }

    handleSetDesiredCameraPosition({ position, target })
  }

  return (
    <button className={styles.button} onClick={handleClick}>
      {element.id}
    </button>
  )
}
